/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Outlook_Revoke_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Disconnect mailbox?" |
*
* @param {Connections_Outlook_Revoke_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_outlook_revoke_confirm_title = /** @type {((inputs?: Connections_Outlook_Revoke_Confirm_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Outlook_Revoke_Confirm_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Postfach trennen?")
	return /** @type {LocalizedString} */ ("Disconnect mailbox?")
});